import React from 'react';
import { Undo2 } from 'lucide-react';
import { useTranslation } from '../../../../i18n/hooks/useTranslation';

interface MatchStartModalProps {
  isOpen: boolean;
  onAction: (action: 'start' | 'break' | 'rollback') => void;
}

export function MatchStartModal({ isOpen, onAction }: MatchStartModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm mx-4">
        <h3 className="text-lg font-semibold mb-4 text-center">
          {t('modals.matchStart.ready')}
        </h3>
        <div className="space-y-3">
          <button
            onClick={() => onAction('start')}
            className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700"
          >
            {t('modals.matchStart.actions.start')}
          </button>
          <button
            onClick={() => onAction('break')}
            className="w-full bg-blue-500 text-white py-3 rounded-lg font-semibold hover:bg-blue-600"
          >
            {t('modals.matchStart.actions.break')}
          </button>
          <button
            onClick={() => onAction('rollback')}
            className="w-full bg-gray-500 text-white py-3 rounded-lg font-semibold hover:bg-gray-600 flex items-center justify-center gap-2"
          >
            <Undo2 size={16} />
            {t('modals.matchStart.actions.rollback')}
          </button>
        </div>
      </div>
    </div>
  );
}

interface GameEndModalProps {
  isOpen: boolean;
  winner: string | null;
  onAction: (action: 'next' | 'break' | 'rollback') => void;
}

export function GameEndModal({ isOpen, winner, onAction }: GameEndModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm mx-4">
        <h3 className="text-lg font-semibold mb-4 text-center">
          {t('modals.gameEnd.winner', { params: { player: winner } })}
        </h3>
        <div className="space-y-3">
          <button
            onClick={() => onAction('next')}
            className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700"
          >
            {t('modals.gameEnd.actions.next')}
          </button>
          <button
            onClick={() => onAction('break')}
            className="w-full bg-blue-500 text-white py-3 rounded-lg font-semibold hover:bg-blue-600"
          >
            {t('modals.gameEnd.actions.break')}
          </button>
          <button
            onClick={() => onAction('rollback')}
            className="w-full bg-gray-500 text-white py-3 rounded-lg font-semibold hover:bg-gray-600 flex items-center justify-center gap-2"
          >
            <Undo2 size={16} />
            {t('modals.gameEnd.actions.rollback')}
          </button>
        </div>
      </div>
    </div>
  );
}